import {
  AuthResTypes,
  LoginSocialParamType,
  LoginSocialType,
  PKCESocialDataType,
  ProfileDataType,
  VerifySocialTokenParams,
} from './types';

import axiosChatbotInstance from 'services/common/chatBotInstance';
import axiosInstance from 'services/common/instance';

export const logoutService = async (): Promise<void> => {
  await axiosInstance.post('customers/logout');
};

export const getProfileService = async (): Promise<ProfileDataType> => {
  const res = await axiosInstance.get('customers/profile');
  return res.data.data;
};

export const loginSocialService = async (data: LoginSocialParamType): Promise<AuthResTypes> => {
  const res = await axiosInstance.post('customers/login-social', data);
  return res.data.data;
};

export const getPKCESocialDataService = async (
  provider: LoginSocialType
): Promise<PKCESocialDataType> => {
  const response = await axiosInstance.post('customers/login-social-pkce', { provider });
  return response.data.data;
};

export const verifySocialService = async (data: VerifySocialTokenParams): Promise<AuthResTypes> => {
  const res = await axiosInstance.post('customers/verify-social-token', data);
  return res.data.data;
};

export const generateCustomerTokenService = async (): Promise<AuthResTypes> => {
  const res = await axiosChatbotInstance.post('chat-bot/account/customer-generate-token');
  return res.data.data;
};
